import { action, makeObservable, observable } from 'mobx';
import { isMobile } from '../../../core/helpers/isMobile';

class DriftBetsStore {
  roundResult = null;

  lastResults = [];

  winAmount = null;

  constructor() {
    makeObservable(this, {
      roundResult: observable,
      lastResults: observable,
      winAmount: observable,
      setRoundResult: action.bound,
      setLastResults: action.bound,
      setWinAmount: action.bound,
      updateLastResults: action.bound,
    });
  }

  setRoundResult(result) {
    this.roundResult = result;
  }

  setWinAmount(amount) {
    this.winAmount = amount;
  }

  setLastResults(lastResults) {
    this.lastResults = lastResults.map((item, index) => ({ ...item, id: index }));
  }

  updateLastResults(lastResult) {
    const updatedLastResult = [...this.lastResults, lastResult];
    if (updatedLastResult.length > (isMobile() ? 3 : 5)) {
      updatedLastResult.splice(0, 1);
    }
    const lastEl = updatedLastResult.pop();
    this.setLastResults(updatedLastResult);
    setTimeout(() => {
      this.setLastResults([...updatedLastResult, lastEl]);
    }, 0);
  }

  resetStore() {
    this.winAmount = null;
    this.roundResult = null;
    this.lastResults = [];
  }
}

export const driftBetsStore = new DriftBetsStore();
